/**
 * Formats a string as a phone number for display
 * @param phoneNumberString
 */
export function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

/**
 * Format birthdate for display
 * @param birthdate
 */
export function formatBirthdateForDisplay(birthdate:string) {
  const splitBirthdate = birthdate.split('-');
  return `${splitBirthdate[1]}/${splitBirthdate[2]}/${splitBirthdate[0]}`;
}

/**
 * Format display birthdate for api
 * @param birthdate
 */
export function formatBirthdateForApi(birthdate:string) {
  const splitBirthdate = birthdate.split('/');
  return `${splitBirthdate[2]}-${splitBirthdate[0]}-${splitBirthdate[1]}`;
}
